import { getBackendUrl } from './api.js';

/**
 * Lazy-fetched, cached copy of GET /api/config. The endpoint is small
 * and never changes between renders, so we fetch once on first access
 * and hand the same promise to every subsequent caller.
 *
 * @type {Promise<{cdnBaseUrl: string, tileBrushTemplateContinuousUrl: string, tileBrushTemplateSegmentedUrl: string, miniatureTemplateUrls: Record<string, string>, [key: string]: any}>|null}
 */
let _configPromise = null;

/**
 * Returns the public config from the api. Safe to call from anywhere that
 * needs cdnBaseUrl, the tile-brush template URLs, or any other field the
 * api hands back from /api/config.
 */
export function loadConfig() {
    if (!_configPromise) {
        _configPromise = fetch(`${getBackendUrl()}/api/config`).then((r) => {
            if (!r.ok) {
                _configPromise = null;
                throw new Error(`Failed to load config: ${r.status}`);
            }
            return r.json();
        });
    }
    return _configPromise;
}
